<template>
  <page-wrapper title="Wallet">
    <div class="page-container">
      <div>
        <wallet-to-earn-user>
        </wallet-to-earn-user>
      </div>
      <div>
        <log-admin-report-by-feature
          target_feature="TOKENX_TRANSACTION"
        ></log-admin-report-by-feature>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import WalletToEarnUser from "../component/WalletToEarnUser"
import LogAdminReportByFeature from '../../../lib/components/LogAdminReportByFeature';

export default {
  components: {
    PageWrapper,
    "wallet-to-earn-user": WalletToEarnUser,
    "log-admin-report-by-feature" :LogAdminReportByFeature
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.page-container {
  padding: 15px;
}

</style>



// WEBPACK FOOTER //
// src/features/morning-coin/pages/WalletToEarnUserPage.vue